import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from "../../lib/http"

export const fetchAffiliateGroupsAdmins = createAsyncThunk('affiliateGroupsAdmins/fetchAffiliateGroupsAdmins', async ({
  limit,
  offset,
  searchQuery,
}, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/affiliate-groups-admins', {
      params: {
        limit,
        offset,
        searchQuery,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch affiliate groups admins'
    return rejectWithValue(errorMessage)
  }
})

export const fetchAllAffiliateGroupsAdminsDropdown = createAsyncThunk('affiliateGroupsAdmins/fetchAllAffiliateGroupsAdminsDropdown', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/affiliate-groups-admins/dropdown/info')
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch affiliate groups admins'
    return rejectWithValue(errorMessage)
  }
})

export const createNewAffiliateGroupsAdmin = createAsyncThunk('affiliateGroupsAdmins/createAffiliateGroupsAdmin', async ({
  userData,
}, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/affiliate-groups-admins', userData)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to create affiliate groups admin'
    return rejectWithValue(errorMessage)
  }
})

export const updateAffiliateGroupsAdmin = createAsyncThunk('affiliateGroupsAdmins/updateAffiliateGroupsAdmin', async ({
  userData, userId
}, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/affiliate-groups-admins/${userId}`, userData)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to update affiliate groups admin'
    return rejectWithValue(errorMessage)
  }
})

export const getAffiliateGroupsAdminById = createAsyncThunk('affiliateGroupsAdmins/getAffiliateGroupsAdminById', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/affiliate-groups-admins/${userId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to fetch affiliate groups admin'
    return rejectWithValue(errorMessage)
  }
})

export const removeAffiliateGroupsAdmin = createAsyncThunk('affiliateGroupsAdmins/removeAffiliateGroupsAdmin', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/affiliate-groups-admins/${userId}`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to delete affiliate groups admin'
    return rejectWithValue(errorMessage)
  }
})

export const resendAffiliateGroupsAdminInvite = createAsyncThunk('affiliateGroupsAdmins/resendAffiliateGroupsAdminInvite', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/affiliate-groups-admins/${userId}/resend-invite`)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to resend invitation'
    return rejectWithValue(errorMessage)
  }
})
